export default __webpack_public_path__ + "static/media/ibuprofen.68e59bdb.png";